export const ADMIN_KEY_STORAGE_KEY = 'atlas-admin-key';

export class AtlasApiError extends Error {
  constructor(message, { status, requestId, payload } = {}) {
    super(message);
    this.name = 'AtlasApiError';
    this.status = status;
    this.requestId = requestId;
    this.payload = payload;
  }
}

export function loadStoredAdminKey() {
  return localStorage.getItem(ADMIN_KEY_STORAGE_KEY) || '';
}

export function storeAdminKey(adminKey) {
  if (adminKey) localStorage.setItem(ADMIN_KEY_STORAGE_KEY, adminKey);
  else localStorage.removeItem(ADMIN_KEY_STORAGE_KEY);
}

export function idempotencyKey(prefix = 'atlas-ui') {
  const random = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `${prefix}-${random}`;
}

export async function atlasFetch(path, { method = 'GET', adminKey = '', body, idempotency, headers = {} } = {}) {
  const requestHeaders = { ...headers };
  if (adminKey) requestHeaders['x-atlas-admin-key'] = adminKey;
  if (body !== undefined) requestHeaders['content-type'] = 'application/json';
  if (idempotency) requestHeaders['idempotency-key'] = idempotency;

  const res = await fetch(path, {
    method,
    headers: requestHeaders,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const requestId = res.headers.get('x-request-id') || '';
  const payload = await res.json().catch(() => null);
  if (!res.ok) {
    const message = typeof payload?.message === 'string' ? payload.message : `HTTP ${res.status}`;
    throw new AtlasApiError(message, { status: res.status, requestId, payload });
  }
  return { payload, requestId, status: res.status };
}

export async function adminGet(path, adminKey) {
  return atlasFetch(path, { adminKey });
}

export async function adminPost(path, body, adminKey, prefix) {
  return atlasFetch(path, { method: 'POST', body, adminKey, idempotency: idempotencyKey(prefix) });
}
